import type { TRuleWithTheme } from '@ackee/fela';

import { BackgroundMode } from 'modules/homepage/PixelatedBackgroundWrapper/constants';

import topRightDivider from '../../../../static/images/contacts/book-call/topRightDivider.svg';
import bottomRightDivider from '../../../../static/images/contacts/book-call/bottomRightDivider.svg';

type Props = { backgroundMode?: BackgroundMode; hasPaddingBottom?: boolean };

export const extendMainWrapper: TRuleWithTheme<Props> = ({ hasPaddingBottom }) => ({
    paddingTop: 0,
    paddingBottom: hasPaddingBottom ? '5rem' : 0,

    tabletLarge: {
        paddingTop: 0,
        paddingBottom: hasPaddingBottom ? '6.5rem' : 0,
    },
});

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 'auto',

    backgroundImage: `url(${topRightDivider}), url(${bottomRightDivider})`,
    backgroundPosition: 'top right, bottom right',
    backgroundRepeat: 'no-repeat',

    desktop: {
        flexDirection: 'row',
        height: 382,
    },

    desktopLarge: {
        backgroundImage: `url(), url(${topRightDivider}), url(${bottomRightDivider})`,
        backgroundPosition: 'bottom 0.8125rem left, top right, bottom right',
    },
});

export const imageSection: TRuleWithTheme = () => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
});

export const imageDescription: TRuleWithTheme = () => ({
    maxWidth: '13rem',
});

export const image: TRuleWithTheme = () => ({
    width: '15rem',
    paddingBottom: '0.1875rem',
    paddingTop: '0.125rem',

    tablet: {
        paddingRight: '2rem',
    },

    desktop: {
        width: '25rem',
    },
});

export const extendPersonPositionText: TRuleWithTheme<Props> = ({ theme, backgroundMode }) => ({
    color: backgroundMode === BackgroundMode.Dark ? theme.colors.white : theme.colors.black,
    paddingBottom: '0.8125rem',
});

export const textContainer: TRuleWithTheme<Props> = ({ theme, backgroundMode }) => ({
    paddingTop: '2rem',
    paddingRight: '1rem',
    maxWidth: '39rem',
    '& h3': {
        color: backgroundMode === BackgroundMode.Dark ? theme.colors.white : theme.colors.black,
    },

    desktop: {
        paddingTop: '3.6875rem',
        paddingRight: 0,
    },
});

export const extendButton: TRuleWithTheme<Props> = ({ theme, backgroundMode }) => ({
    fontSize: 32,
    fontStyle: 'normal',
    fontWeight: 800,
    textDecorationThickness: 2,
    textUnderlineOffset: '9px',
    color: backgroundMode === BackgroundMode.Dark ? theme.colors.cyan : theme.colors.blue,
});
